import { createStore } from 'vuex'
import createPersistedState from 'vuex-persistedstate'


const store = createStore({
	state() {
		return{
			userId : null,
			userEmail: null,
			onScan : false
		}
	},
	mutations: {
		changeId(state, userId) {
			state.userId = userId
		},
		changeEmail(state, userEmail) {
			state.userEmail = userEmail
		},
		changeLoc(state, onScan) {
			state.onScan = onScan
		}
	},
	getters: {
		isLoggedIn(state){ 
			return state.userId !== null
		},
		getUserId(state){ 
			return state.userId
		},
		getUserEmail(state){ 
			return state.userEmail
		},
		isOnScan(state) {
			return state.onScan
		}

	},
	plugins: [createPersistedState()]
})

export default store